export default function PeriodAllreadyReservedModal(
    $scope,
    period,
    lane,
    $element,
    moment,
    close
) {
    $scope.period = period;

    $scope.message =
        "Kan bookes fra d. " +
        moment(period.AvailableFrom).format("DD. MMMM YYYY") +
        ".";

    $scope.modalClose = function (period) {
        $element.modal("hide");

        close(period, 500); // close, but give 500ms for bootstrap to animate
    };
}
